<template>
    <b-modal id="add-startups" title="Add Startups">

        <multiselect
            class="multiselect--complex multiselect-mid"
            v-model="startups"
            :options="startupsList"
            select-label=""
            deselect-label=""
            label="name"
            track-by="name"
            :multiple="true"
            placeholder="Start typing..."
            @search-change="updateStartupsList"
        >
            <template slot="option" slot-scope="props"><img :src="LogoHelper.getLogo(props.option.logo)" style="width:40px" alt=""> {{ props.option.name }}</template>
        </multiselect>

        <template #modal-footer>
            <b-button variant="primary" @click="addStartups" size="lg" :disabled="!startups.length">Add</b-button>
        </template>
    </b-modal>
</template>

<script>
import multiselect from "vue-multiselect"
import trackers from "@/services/trackers.service"
import trackersStartups from "@/services/trackers-startups.service"
import startups from "@/services/startups.service";

export default {
    props: {
        trackerId: Number
    },

    components: {
        multiselect,
    },

    data() {
        return {
            startupsList: [],
            startups: [],
            lastAddedStartups: [],
        }
    },

    mounted() {
        startups.getLastAddedStartups().then(response => {
            this.lastAddedStartups = response.data
        })
    },

    methods: {
        updateStartupsList(search) {
            if (search.length) {
                trackers.getStartupsListToAdd(this.trackerId, search).then(response => {
                    this.startupsList = response.data
                })
            }
            else {
                this.startupsList = this.lastAddedStartups
            }
        },

        open() {
            this.startups = []
            this.startupsList = this.lastAddedStartups
            this.$bvModal.show('add-startups')
        },

        addStartups() {
            let startupsIds = this.arrayHelper.arrayColumn(this.startups, 'id')
            trackersStartups.addStartups(startupsIds, [this.trackerId]).then(() => {
                this.$emit('startupsAdded')
                this.$bvModal.hide('add-startups')
            })
        }
    }
}
</script>

<style scoped>

</style>